<template>
  <span>
    <template v-if="location.currentDayOperatingSchedule.isOpen">
      <span class="comma-list">
        <span
          v-for="schedule in location.currentDayOperatingSchedule.openCloseItems"
          :key="schedule.open"
          class="comma-list__item"
        >
          {{ $timeOfDay(schedule.open, true) }} – {{ $timeOfDay(schedule.close, true) }}
        </span>
      </span>

      <span
        v-if="location.currentDayOperatingSchedule.status === 'Closed'"
        class="danger"
      >
        (Closed)
      </span>
    </template>

    <span
      v-else
      class="danger"
    >
      Closed Today
    </span>
  </span>
</template>



<script>
  export default {
    name: 'CurrentDayStoreHours',

    props: {
      location: {
        type: Object,
        required: true
      }
    }
  };
</script>
